<template>
	<label :for="id" ref="wrapper" class="input-wrapper" :style="'--selected-color: #'+currentValue">
		<div class="row centered" v-if="label">
			<div class="txt-input-label">{{ label }}</div>
		</div>
		<div class="row centered input-element">
			<input ref="input" type="color" :id="id" :name="name" :value="'#'+currentValue" @input="changeColor">
		</div>
	</label>
</template>

<script>
import {getRandomAlphanumericString} from "@/shared/helpers/strings";

let defaultColor = "0752A3";

export default {
	name: "AppColorPicker",
	emits: ["changing-color", "changed-color"],
	data() {
		return {
			currentValue: validateColor(this.value),
			editingTimeout: false,
		}
	},
	props: {
		name: {type: String, default: "colorPicker"},
		label: {type: String, default: null},
		value: {type: String, default: defaultColor},
	},
	computed: {
		id() {
			return 'color-picker-' + getRandomAlphanumericString();
		},
	},
	methods: {
		changeColor(e) {
			this.currentValue = e.target.value.replace("#", "");
			this.$emit("changing-color", '#'+this.currentValue);

			// Emits changed-color only if the user has stopped editing (500ms delay)
			// We don't use the "change" event because it doesn't work reliably across browsers
			if(this.editingTimeout) {
				clearTimeout(this.editingTimeout);
			}
			this.editingTimeout = setTimeout(() => {
				this.$emit("changed-color", '#'+this.currentValue);
				this.editingTimeout = false;
			}, 500);
		},
	},
	watch: {
		value(newVal) {
			this.currentValue = validateColor(newVal);
		}
	}
}

function validateColor(color) {
	if(!color) {
		return defaultColor;
	}
	let colorR = color.replace("#", "");
	let colorRegex = /^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
	let result = defaultColor;
	if(colorRegex.test(colorR)) {
		result = colorR;
	}
	return result;
}
</script>

<style lang="scss" scoped>

.input-wrapper {
	cursor: pointer;

	.input-element {
		position: relative;
		cursor: pointer;
		margin: 0 auto;
		width: 35px;
		height: 35px;
		padding: 6px;
		background-color: $bg_0;
		border-radius: 13px;
		box-shadow: 0 1px 2px var(--color-box-shadow-3);

		& * {
			pointer-events: none;
		}

		&:after {
			content: "";
			position: absolute;
			top: 3px;
			left: 3px;
			height: 29px;
			width: 29px;
			border-radius: 11px;
			box-shadow: inset 0 1px 2px var(--color-alpha-4);
			background-color: var(--selected-color);
		}

		input {
			cursor: pointer;
			border-radius: 13px;
			height: 100%;
			width: 100%;
			border: none;
			outline: none;
			-webkit-appearance: none;
			opacity: 0;

			&::-webkit-color-swatch-wrapper {
				padding: 0;
			}

			&::-webkit-color-swatch {
				opacity: 0;
			}
		}
	}

}

</style>